import { createFileRoute } from "@tanstack/react-router"

import { SettingsQrSheetsPage } from "@/pages/settings/qr-sheets"

// Open to any authenticated user so editors and viewers see the branding read-only; the page
// hides the controls without ACCOUNT_SETTINGS_UPDATE and the backend PATCH still enforces it.
export const Route = createFileRoute("/_authenticated/settings/qr-sheets")({
  component: SettingsQrSheetsPage,
})
